import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormioCustomComponent, FormioComponent } from 'dp-formio';

@Component({
	selector: 'app-redirection-button-wrapper',
	templateUrl: './redirection-button-wrapper.component.html',
	styleUrls: ['./redirection-button-wrapper.component.scss'],
})
export class RedirectionButtonWrapperComponent implements FormioCustomComponent<any> {
	@ViewChild(FormioComponent) formComponent: FormioComponent;

	dir: 'rtl' | 'ltr';
	@Input() required: boolean;
	@Input() value: any = {};
	@Output() valueChange = new EventEmitter<any>();
	@Input() disabled: boolean;
	@Input() viewOnly: boolean;
	@Input() data: any;
	@Input() customOptions: any;
	@Input() formioComponent: any;

	constructor(private router: Router) { }

	onRoute() {
		let parentRoute = '';
		for (let index = 5; index < this.data.currentRoute.split('/').length; index++) {
			parentRoute = `${parentRoute}${this.data.currentRoute.split('/')[index]}/`;
		}

		const taskId =
			this.data.currentRoute
				.split('/')
			[this.data.currentRoute.split('/').length - 1]?.split('?')[0] || '';

		this.router.navigate(
			[
				`/resources/eligibilityRequirments/${this.data.serviceId}/${this.data.varSubmissionId}/${this.customOptions.targetFormKey}/${this.customOptions.summaryResourceKey}`,
			],
			{ queryParams: { parentRoute, taskId }, state: { isNotAssigned: this.disabled || this.viewOnly } }
		);
	}
}
